/**
 * @generated SignedSource<<a94326625bd508ceb25c76a2e153127f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type LearningSortEnum = "CREATION_DATE_ASC" | "CREATION_DATE_DESC" | "ID_ASC" | "ID_DESC" | "SUMMARY_ASC" | "SUMMARY_DESC";
export type TrackViewEvent = "DIRECT" | "INDIRECT" | "SKIP";
export type GoalHighlightsTabQuery$variables = {
  isDecisions: boolean;
  isLearnings: boolean;
  isRisks: boolean;
  key: string;
  learningsSort?: ReadonlyArray<LearningSortEnum | null> | null;
  tagCount?: number | null;
  trackViewEvent?: TrackViewEvent | null;
};
export type GoalHighlightsTabQuery$data = {
  readonly goal: {
    readonly decisions?: {
      readonly __id: string;
      readonly count: number;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
        } | null;
      } | null> | null;
    } | null;
    readonly id: string;
    readonly learnings?: {
      readonly __id: string;
      readonly count: number;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
        } | null;
      } | null> | null;
    } | null;
    readonly risks?: {
      readonly __id: string;
      readonly count: number;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
        } | null;
      } | null> | null;
    } | null;
    readonly state: {
      readonly label: string | null;
    } | null;
    readonly tags: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly watcherCount: number;
        } | null;
      } | null> | null;
      readonly " $fragmentSpreads": FragmentRefs<"LearningTags_data">;
    } | null;
    readonly uuid: string;
    readonly watcherCount: number;
    readonly workspace: {
      readonly uuid: string;
    };
    readonly " $fragmentSpreads": FragmentRefs<"GoalHighlightsList" | "NewGoalHighlightsPanel">;
  } | null;
};
export type GoalHighlightsTabQuery = {
  response: GoalHighlightsTabQuery$data;
  variables: GoalHighlightsTabQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isDecisions"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isLearnings"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isRisks"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "key"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "learningsSort"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tagCount"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "trackViewEvent"
},
v7 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "key"
  },
  {
    "kind": "Variable",
    "name": "trackViewEvent",
    "variableName": "trackViewEvent"
  }
],
v8 = {
  "kind": "ScalarField",
  "name": "id"
},
v9 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v10 = [
  {
    "kind": "ScalarField",
    "name": "label"
  }
],
v11 = {
  "concreteType": "GoalState",
  "kind": "LinkedField",
  "name": "state",
  "plural": false,
  "selections": (v10/*: any*/)
},
v12 = {
  "kind": "Variable",
  "name": "sort",
  "variableName": "learningsSort"
},
v13 = [
  (v12/*: any*/)
],
v14 = {
  "kind": "ScalarField",
  "name": "count"
},
v15 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v16 = [
  (v8/*: any*/),
  (v15/*: any*/)
],
v17 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v18 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v19 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v20 = {
  "kind": "ScalarField",
  "name": "watcherCount"
},
v21 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "tagCount"
  }
],
v22 = {
  "kind": "Variable",
  "name": "tagCount",
  "variableName": "tagCount"
},
v23 = {
  "concreteType": "Workspace",
  "kind": "LinkedField",
  "name": "workspace",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v8/*: any*/)
  ]
},
v24 = {
  "kind": "ScalarField",
  "name": "name"
},
v25 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 200
  },
  (v12/*: any*/)
],
v26 = {
  "kind": "ScalarField",
  "name": "ari"
},
v27 = {
  "kind": "ScalarField",
  "name": "key"
},
v28 = [
  {
    "concreteType": "UserPII",
    "kind": "LinkedField",
    "name": "pii",
    "plural": false,
    "selections": [
      (v24/*: any*/),
      {
        "kind": "ScalarField",
        "name": "picture"
      },
      {
        "kind": "ScalarField",
        "name": "accountId"
      }
    ]
  },
  {
    "kind": "ScalarField",
    "name": "aaid"
  },
  (v8/*: any*/)
],
v29 = [
  (v8/*: any*/),
  (v15/*: any*/),
  (v9/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "kind": "ScalarField",
        "name": "summary"
      },
      {
        "kind": "ScalarField",
        "name": "description"
      },
      (v26/*: any*/),
      {
        "concreteType": "Project",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v27/*: any*/),
          (v24/*: any*/),
          (v9/*: any*/),
          (v26/*: any*/),
          (v23/*: any*/),
          {
            "concreteType": "ProjectState",
            "kind": "LinkedField",
            "name": "state",
            "plural": false,
            "selections": (v10/*: any*/)
          }
        ]
      },
      {
        "concreteType": "Goal",
        "kind": "LinkedField",
        "name": "goal",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v27/*: any*/),
          (v24/*: any*/),
          (v9/*: any*/),
          (v26/*: any*/),
          (v23/*: any*/),
          (v11/*: any*/)
        ]
      },
      {
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "creator",
        "plural": false,
        "selections": (v28/*: any*/)
      },
      {
        "kind": "ScalarField",
        "name": "creationDate"
      },
      {
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "lastEditedBy",
        "plural": false,
        "selections": (v28/*: any*/)
      },
      {
        "kind": "ScalarField",
        "name": "lastEditedDate"
      },
      {
        "kind": "ClientExtension",
        "selections": [
          {
            "kind": "ScalarField",
            "name": "isRecentlyAdded"
          }
        ]
      }
    ],
    "type": "Highlight",
    "abstractKey": "__isHighlight"
  }
],
v30 = [
  "sort"
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "GoalHighlightsTabQuery",
    "selections": [
      {
        "alias": "goal",
        "args": (v7/*: any*/),
        "concreteType": "Goal",
        "kind": "LinkedField",
        "name": "goalByKey",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": (v8/*: any*/),
            "action": "LOG",
            "path": "goal.id"
          },
          (v9/*: any*/),
          (v11/*: any*/),
          {
            "kind": "RequiredField",
            "field": {
              "concreteType": "Workspace",
              "kind": "LinkedField",
              "name": "workspace",
              "plural": false,
              "selections": [
                (v9/*: any*/)
              ]
            },
            "action": "LOG",
            "path": "goal.workspace"
          },
          {
            "condition": "isLearnings",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "learnings",
                "args": (v13/*: any*/),
                "concreteType": "LearningConnection",
                "kind": "LinkedField",
                "name": "__GoalHighlightsList__learnings_connection",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  {
                    "concreteType": "LearningEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "Learning",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v16/*: any*/)
                      },
                      (v17/*: any*/)
                    ]
                  },
                  (v18/*: any*/),
                  (v19/*: any*/)
                ]
              }
            ]
          },
          {
            "condition": "isRisks",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "risks",
                "args": (v13/*: any*/),
                "concreteType": "RiskConnection",
                "kind": "LinkedField",
                "name": "__GoalHighlightsList__risks_connection",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  {
                    "concreteType": "RiskEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "Risk",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v16/*: any*/)
                      },
                      (v17/*: any*/)
                    ]
                  },
                  (v18/*: any*/),
                  (v19/*: any*/)
                ]
              }
            ]
          },
          {
            "condition": "isDecisions",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "decisions",
                "args": (v13/*: any*/),
                "concreteType": "DecisionConnection",
                "kind": "LinkedField",
                "name": "__GoalHighlightsList__decisions_connection",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  {
                    "concreteType": "DecisionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "Decision",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v16/*: any*/)
                      },
                      (v17/*: any*/)
                    ]
                  },
                  (v18/*: any*/),
                  (v19/*: any*/)
                ]
              }
            ]
          },
          (v20/*: any*/),
          {
            "args": (v21/*: any*/),
            "concreteType": "TagConnection",
            "kind": "LinkedField",
            "name": "tags",
            "plural": false,
            "selections": [
              {
                "concreteType": "TagEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Tag",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v20/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "FragmentSpread",
                "name": "LearningTags_data"
              }
            ]
          },
          {
            "args": [
              (v12/*: any*/),
              (v22/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "GoalHighlightsList"
          },
          {
            "args": [
              (v22/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "NewGoalHighlightsPanel"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v6/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "GoalHighlightsTabQuery",
    "selections": [
      {
        "alias": "goal",
        "args": (v7/*: any*/),
        "concreteType": "Goal",
        "kind": "LinkedField",
        "name": "goalByKey",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v9/*: any*/),
          (v11/*: any*/),
          (v23/*: any*/),
          (v20/*: any*/),
          {
            "args": (v21/*: any*/),
            "concreteType": "TagConnection",
            "kind": "LinkedField",
            "name": "tags",
            "plural": false,
            "selections": [
              {
                "concreteType": "TagEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Tag",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v20/*: any*/),
                      (v24/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "isLearnings",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v25/*: any*/),
                "concreteType": "LearningConnection",
                "kind": "LinkedField",
                "name": "learnings",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  {
                    "concreteType": "LearningEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "Learning",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v29/*: any*/)
                      },
                      (v17/*: any*/)
                    ]
                  },
                  (v18/*: any*/),
                  (v19/*: any*/)
                ]
              },
              {
                "args": (v25/*: any*/),
                "filters": (v30/*: any*/),
                "handle": "connection",
                "key": "GoalHighlightsList__learnings",
                "kind": "LinkedHandle",
                "name": "learnings"
              }
            ]
          },
          {
            "condition": "isRisks",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v25/*: any*/),
                "concreteType": "RiskConnection",
                "kind": "LinkedField",
                "name": "risks",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  {
                    "concreteType": "RiskEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "Risk",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v29/*: any*/)
                      },
                      (v17/*: any*/)
                    ]
                  },
                  (v18/*: any*/),
                  (v19/*: any*/)
                ]
              },
              {
                "args": (v25/*: any*/),
                "filters": (v30/*: any*/),
                "handle": "connection",
                "key": "GoalHighlightsList__risks",
                "kind": "LinkedHandle",
                "name": "risks"
              }
            ]
          },
          {
            "condition": "isDecisions",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v25/*: any*/),
                "concreteType": "DecisionConnection",
                "kind": "LinkedField",
                "name": "decisions",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  {
                    "concreteType": "DecisionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "Decision",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v29/*: any*/)
                      },
                      (v17/*: any*/)
                    ]
                  },
                  (v18/*: any*/),
                  (v19/*: any*/)
                ]
              },
              {
                "args": (v25/*: any*/),
                "filters": (v30/*: any*/),
                "handle": "connection",
                "key": "GoalHighlightsList__decisions",
                "kind": "LinkedHandle",
                "name": "decisions"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "60fc323e67cc298b60671808d70bf4a3",
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "goal",
            "learnings"
          ]
        },
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "goal",
            "risks"
          ]
        },
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "goal",
            "decisions"
          ]
        }
      ]
    },
    "name": "GoalHighlightsTabQuery",
    "operationKind": "query",
    "text": "query GoalHighlightsTabQuery(\n  $key: String!\n  $trackViewEvent: TrackViewEvent\n  $learningsSort: [LearningSortEnum]\n  $tagCount: Int\n  $isLearnings: Boolean!\n  $isRisks: Boolean!\n  $isDecisions: Boolean!\n) {\n  goal: goalByKey(key: $key, trackViewEvent: $trackViewEvent) {\n    id\n    uuid\n    state {\n      label\n    }\n    workspace {\n      uuid\n      id\n    }\n    learnings(sort: $learningsSort, first: 200) @include(if: $isLearnings) {\n      count\n      edges {\n        node {\n          id\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    risks(sort: $learningsSort, first: 200) @include(if: $isRisks) {\n      count\n      edges {\n        node {\n          id\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    decisions(sort: $learningsSort, first: 200) @include(if: $isDecisions) {\n      count\n      edges {\n        node {\n          id\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    watcherCount\n    tags(first: $tagCount) {\n      edges {\n        node {\n          id\n          watcherCount\n        }\n      }\n      ...LearningTags_data\n    }\n    ...GoalHighlightsList_3Org6Z\n    ...NewGoalHighlightsPanel_2MWLOs\n  }\n}\n\nfragment GoalHighlightsList_3Org6Z on Goal {\n  learnings(sort: $learningsSort, first: 200) @include(if: $isLearnings) {\n    count\n    edges {\n      node {\n        id\n        uuid\n        ... on Highlight {\n          __isHighlight: __typename\n          ...Learning_data\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  risks(sort: $learningsSort, first: 200) @include(if: $isRisks) {\n    count\n    edges {\n      node {\n        id\n        uuid\n        ... on Highlight {\n          __isHighlight: __typename\n          ...Learning_data\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  decisions(sort: $learningsSort, first: 200) @include(if: $isDecisions) {\n    count\n    edges {\n      node {\n        id\n        uuid\n        ... on Highlight {\n          __isHighlight: __typename\n          ...Learning_data\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  watcherCount\n  tags(first: $tagCount) {\n    ...LearningTags_data\n  }\n}\n\nfragment LearningModifierSignatures_data on Highlight {\n  __isHighlight: __typename\n  uuid\n  ari\n  project {\n    key\n    ari\n    id\n  }\n  goal {\n    key\n    ari\n    id\n  }\n  creator {\n    pii {\n      name\n    }\n    ...UserAvatar_2aqwkz\n    id\n  }\n  creationDate\n  lastEditedBy {\n    pii {\n      name\n    }\n    ...UserAvatar_2aqwkz\n    id\n  }\n  lastEditedDate\n}\n\nfragment LearningTags_data on TagConnection {\n  edges {\n    node {\n      id\n      name\n      watcherCount\n    }\n  }\n}\n\nfragment Learning_data on Highlight {\n  __isHighlight: __typename\n  __typename\n  id\n  summary\n  description\n  uuid\n  ari\n  project {\n    id\n    key\n    name\n    uuid\n    ari\n    workspace {\n      uuid\n      id\n    }\n    state {\n      label\n    }\n  }\n  goal {\n    id\n    key\n    name\n    uuid\n    ari\n    workspace {\n      uuid\n      id\n    }\n    state {\n      label\n    }\n  }\n  ...LearningModifierSignatures_data\n}\n\nfragment NewGoalHighlightsPanel_2MWLOs on Goal {\n  watcherCount\n  tags(first: $tagCount) {\n    edges {\n      node {\n        watcherCount\n        name\n        id\n      }\n    }\n  }\n}\n\nfragment UserAvatar_2aqwkz on User {\n  aaid\n  pii {\n    picture\n    accountId\n  }\n}\n"
  }
};
})();

(node as any).hash = "2917a8cfefd1a68c19ad55180f5b4fa2";

export default node;
